import { render } from "./NewsCards.vue?vue&type=template&id=229926d9&scoped=true"
import script from "./NewsCards.vue?vue&type=script&lang=js"
export * from "./NewsCards.vue?vue&type=script&lang=js"

import "./NewsCards.vue?vue&type=style&index=0&id=229926d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229926d9"]])

export default __exports__